// There are forms available to users where they can view and
// update their payment information which don't get reset by
// on-load-reset-form.js. In some cases the radio buttons in
// this view aren't "checked" and need to be clicked. Script
// clicks things if "opportunity_id" is detected, which gets
// set by PHP in:
// views/components/donation-form/donation-form.php.

import $ from 'jquery';

var opportunityId = $('#opportunity_id');
if (opportunityId.length) {
    var radioButtons = $('input[type=radio]:checked');
    if ($(radioButtons).each(function() {
        $(this).closest('label').trigger('click');
    }));
}
